import { render } from "./Cursor.vue?vue&type=template&id=4ce09cd4&ts=true"
import script from "./Cursor.vue?vue&type=script&lang=ts"
export * from "./Cursor.vue?vue&type=script&lang=ts"

import "./Cursor.vue?vue&type=style&index=0&id=4ce09cd4&lang=scss"

import exportComponent from "C:\\PROJEKTE\\GAMES\\shootEm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__